import React from 'react';
import { SubMenuItemsProps } from './types';

export const SubMenuItems: React.VFC<SubMenuItemsProps> = ({
  isSelected,
  menuItems,
  parentItem,
  ariaControlsId,
  arrowIconSvg,
  isintra
}) => {
  let rowCount = '4';

  let rowsModifierCssClass = '';
  // Färre än 4 menyalternativ
  if (menuItems.length / 4 < 1) {
    rowCount = menuItems.length.toString();
    rowsModifierCssClass = 'main-menu__sub-items-wrapper--' + rowCount + '-rows';
    // Fler än 16 menyalternativ
  } else if (menuItems.length / 16 > 1) {
    rowCount = Math.ceil(menuItems.length / 4).toString();
    rowsModifierCssClass = 'main-menu__sub-items-wrapper--' + rowCount + '-rows';
  }

  return (
    <div
      id={ariaControlsId}
      className={`main-menu__content container-fluid rounded-corner-md-bottom-right ${isintra ? 'light' : 'dark'} ${isSelected ? 'main-menu__content--open' : ''}`}
      data-testid="submenu"
    >
      {!isintra && (
        <div className="main-menu__parent-item bg-vgr-primary-dark">
          <div className="container grid">
            <a className="g-col-12" href={parentItem.href}>
              {parentItem.text}
              <div dangerouslySetInnerHTML={{ __html: arrowIconSvg }}></div>
            </a>
          </div>
        </div>
      )}

      <div className="container">
        <ul className={`main-menu__sub-items-wrapper ${rowsModifierCssClass}`}>
          {menuItems.map((subItem) => (
            <li key={subItem.pageId} className={`main-menu__sub-item ${isintra ? "main-menu__sub-item--flexitem" : ""}`}>
              <a href={subItem.href} className='main-menu__sub-item-content'>
                {isintra && subItem.icon && (
                  <svg className={`streamline-icon ${subItem.icon}`} viewBox="0 0 38 38">
                    <use xlinkHref={`${subItem.icon}`} ></use>
                  </svg>
                )}

                {isintra ? (
                  <div>
                    <span className='main-menu__sub-item-content-link-header'>{subItem.text}</span>
                    {subItem.description && <span className='main-menu__sub-item-content-description'>{subItem.description}</span>}
                  </div>
                ) : (
                  subItem.text
                )}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>

  );
};
